import React, { useState } from 'react';
import { View } from 'react-native';

import RelayTable from 'app/src/elements/Table/RelayTable';
import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { THINGS } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'parent',
    label: 'Parent',
    sort: 'prevent',
    value: ({ value }) => value?.name,
    content: ({ entry, value }) => (
      value && (
        <Link to={`/things/${entry.parent.id}`}>
          <Text>{value}</Text>
        </Link>
      )
    ),
  },
  {
    key: 'emoji',
    label: 'Emoji',
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/things/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  }
];

const Things = () => {
  const [refetch, setRefetch] = useState();

  return (
    <View>
      <Title>Things</Title>

      <Link to="/things/new">
        <Text>Add Thing</Text>
      </Link>

      <RelayTable
        query={THINGS}
        queryName="things"
        columns={columns}
        setRefetch={setRefetch}
      />
    </View>
  );
};

export default Things;
